// import { BinaryOperator } from '@angular/compiler';
// import { stringify } from '@angular/compiler/src/util';

import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataSharingService } from "../services/data-sharing.service";
import { CommonDataService } from "../services/common-data.service";
import { Location } from "../models/location";
import { ClassSchedule } from "../models/class-schedule";
import { ClassScheduleSession } from "../models/class-schedule-session";
import { Month } from "../models/month";
import { Year } from "../models/year";
import { StudentService } from "../services/student.service";
import { PaymentService } from "../services/payment.service";
import { PaymentPost } from "../models/payment-post";
import { StudentGet } from "../models/student-get";
import { ClassMaster } from "../models/class-master";
import { Setting } from "../models/settings";
import { UserService } from "../services/user.service";

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.css"],
})
export class PaymentComponent implements OnInit {
  paymentComponent = this;
  location: Location;
  classSchedule: ClassSchedule;
  classMaster: ClassMaster;
  student: StudentGet = new StudentGet();
  classScheduleSessions: ClassScheduleSession[];
  months: Month[] = [];
  selectedMonth: Month = new Month();
  years: Year[] = [];
  selectedYear: Year = new Year();
  payment: PaymentPost = new PaymentPost();
  formComplete: any;
  displayModal1: string;
  priceSetting: Setting = new Setting();
  submitted: boolean = false;
  isStudent: boolean = false;
  isRegisteringAdditional: boolean = false;
  discount: string = "0.00";
  finalPrice: string = "0.00";
  formattedName: string;
  payatdoor: boolean = false;
  totalprice: string = "0.00";
  halfrate: string = "";
  chkno: string = "";

  constructor(
    private _router: Router,
    private _dataService: DataSharingService,
    private _commonService: CommonDataService,
    private _studentService: StudentService,
    private _paymentService: PaymentService,
    private _user: UserService
  ) {
    this.getData();
  }

  setDiscount(event) {
    const discount = parseFloat(this.discount).toFixed(2);
    this.discount = discount == "NaN" ? "0.00" : this.discount;
    // this.finalPrice = (parseFloat(this.priceSetting.description) - parseFloat(this.discount)).toFixed(2);
    this.finalPrice = (
      parseFloat(this.priceSetting.description) *
      (this.isRegisteringAdditional ? 2 : 1) -
      parseFloat(this.discount)
    ).toFixed(2);
  }

  getData() {
    const roleId = this._dataService.getRoleId();
    const location = this._dataService.getSelectedLocation();
    const classSchedule = this._dataService.getSelectedClassSchedule();
    const student = this._dataService.getCurrentStudent();
    const classmaster = this._dataService.getClassMaster();
    this.isStudent = roleId === this._user.roleStudent;
    this.isRegisteringAdditional = this._dataService.getRegisterAdditional();

    if (location !== null) {
      this.location = location.location;
    } else {
      this.location = new Location();
    }

    if (classSchedule !== null) {
      this.classSchedule = classSchedule.classSchedule;
      this.classScheduleSessions =
        classSchedule.classSchedule.classScheduleSessions;
    } else {
      this.classSchedule = new ClassSchedule();
    }

    if (student !== null) {
      this.student = student.student;
      this.payment.firstName = this.student.firstName;
      this.payment.lastName = this.student.lastName;
      this.payment.address = this.student.address.address1;
      this.payment.city = this.student.address.city;
      this.payment.zip = this.student.address.zipCode;
    } else {
      this.student = new StudentGet();
    }

    if (classmaster !== null) {
      this.classMaster = classmaster.classmaster;
    } else {
      this.classMaster = new ClassMaster();
    }
  }

  ngOnInit() {
    // Get Pricecs
    this.getPrices();

    this.displayModal1 = "none";
    // Get months
    this.getMonths();

    // Get Years
    this.getYears();
    this.formattedName =
      this.student.firstName +
      " " +
      (this.student.middleName == null ? "" : this.student.middleName + " ") +
      this.student.lastName;
  }

  submit() {
    this.submitted = true;
    // DEFAULT CLASS INFORMATION FOR TEST:
    this.payment.itemId = "001";
    this.payment.classname = this.classMaster.title;
    this.payment.quantity = "1";
    let p = +this.finalPrice;
    // let p = +this.classMaster.price;
    p = p === 0 ? 24.95 : p;
    this.payment.unitPrice = p.toString();
    const q = +this.payment.quantity;
    const t = p * q;
    this.payment.amount = t.toString();

    this._paymentService.makePayment(this.payment).subscribe(
      (res) => this.makePaymentSuccess(res),
      (error) => this.makePaymentFailed(error),
      () => console.log("makePayment Success!")
    );
  }

  ValidateInput() {
    this.formComplete = false; // Implement this
    this.submitted = false;
  }

  onModalClose1() {
    this.displayModal1 = "none";
    this.submitted = false;
  }

  makePaymentSuccess(result: any) {
    if (
      result != null &&
      result.messages != null &&
      result.messages.resultCode != null &&
      result.messages.resultCode === 0 &&
      result.transactionResponse.responseCode == "1"
    ) {
      this.addStudent();
    } else {
      this.displayModal1 = "block";
    }
  }

  makePaymentFailed(errors: any) {
    this.displayModal1 = "block";
  }

  getPrices() {
    const classTypeId = this._dataService.getClassTypeId();
    const name = classTypeId == "1" ? "price8Hour" : "price4Hour";
    this._dataService.getSetting("Price", name).subscribe(
      (res) => this.getSettingSuccsess(res),
      (error) => this.settingFailure(error),
      () => console.log("Get " + name + " Complete!")
    );
  }
  settingFailure(error: any) {
    return "Settings error";
  }
  getSettingSuccsess(result: any) {
    const setting = result[0] as Setting;
    this.priceSetting = setting;
    // this.finalPrice = (parseFloat(this.priceSetting.description) - parseFloat(this.discount)).toFixed(2);
    this.finalPrice = (
      parseFloat(this.priceSetting.description) *
      (this.isRegisteringAdditional ? 2 : 1) -
      parseFloat(this.discount)
    ).toFixed(2);

    // skip payment, just register for the class
    // if (this.location.dipCommEd) {
    //   this.addStudent();
    // }
  }

  payAtDoor() {
    this.payatdoor = true;
    this.addStudent();
  }

  addStudent() {
    this._dataService.setRegisterProgress("4");
    const classSchedule = this._dataService.getSelectedClassSchedule()
      .classSchedule;
    const student = this._dataService.getCurrentStudent().student;
    this.halfrate = (
      parseFloat(this.finalPrice) / (this.isRegisteringAdditional ? 2 : 1)
    ).toFixed(2);
    if (this.location.dipCommEd) {
      this.payatdoor = true;
    }
    this.chkno = this.payatdoor ? "  " : "CC"; // was ? 'LOC' : 'ppd';
    // let paymessge = 'Payment of $' + this.halfrate;
    let paymessge = this.payatdoor
      ? " must be paid at the time of class with a check or money order. Instructor will specify who checks are made payable to at the time of class."
      //? ((this.location.dipCommEd)
      //  ? " must be made to Community Education with a check or money order at the time of the class."
      //  : " must be paid at the time of class with a check or money order. Instructor will specify who checks are made payable to at the time of class."
      //)
      //? " must be made to " +
      //  (this.location.dipCommEd ? "Community Education" : "MHSRC") +
      //  " with a check or money order at the time of the class."
      : " has been made in full.";
    const halfpay = "Payment of $" + this.halfrate + paymessge;
    const fullpay = "Payment of $" + this.finalPrice + paymessge;
    this._dataService.setPaymentMessage(halfpay);
    this._dataService.setFullPaymentMessage(fullpay);
    this._studentService
      .addStudentClass(student.id, classSchedule.id, this.halfrate, this.chkno)
      .subscribe(
        (res) => this.addStudentClassSuccess(res),
        (error) => this.addStudentClassFailed(error),
        () => console.log("addStudentClass Saved!")
      );
  }
  addStudentClassSuccess(result: any) {
    if (!this.isRegisteringAdditional) {
      this._router.navigate(["payment-confirmation"]);
    } else {
      const classSchedule = this._dataService.getSelectedClassSchedule()
        .classSchedule;
      const student = this.student.friendStudent;
      const paymessge = this._dataService.getPaymentMessage();
      this.isRegisteringAdditional = false;
      this._studentService
        .addStudentClass(
          student.id,
          classSchedule.id,
          this.halfrate,
          this.chkno
        )
        .subscribe(
          (res) => this.addStudentClassSuccess(res),
          (error) => this.addStudentClassFailed(error),
          () => console.log("addFriendClass Saved!")
        );
    }
  }
  addStudentClassFailed(errors: any) {}

  editLocation() {
    this._router.navigate(["select-location"]);
  }

  getMonths() {
    this._commonService.getMonths().subscribe(
      (months) => this.setMonths(months),
      (error) => console.log("Error: " + error),
      () => console.log("Completed!")
    );
  }

  setMonths(months: any) {
    this.months = months;
    const defaultMonth = {
      id: "-1",
      number: "-1",
      name: "month",
      abbr: "month",
    };

    this.months.splice(0, 0, defaultMonth);
    // this.months[0] = defaultMonth;
    this.selectedMonth = this.months[0];
  }

  getYears() {
    this._commonService.getYearRange(15).subscribe(
      (years) => this.setYears(years),
      (error) => console.log("Error: " + error),
      () => console.log("Completed!")
    );
  }

  setYears(years: any) {
    this.years = years;
    const defaultYear = {
      year: "year",
    };
    this.years.splice(0, 0, defaultYear);
    // this.years[0] = defaultYear;
    this.selectedYear = this.years[0];
  }

  expirationMonthChanged(event: any) {
    this.selectedMonth.id = event.id;
    this.selectedMonth.number = event.number;
    this.selectedMonth.name = event.name;
    this.selectedMonth.abbr = event.abbr;
    this.payment.month = event.number;
    console.log("month changed"); // working
  }

  expirationYearChanged(event: any) {
    this.selectedYear.year = event.year;
    this.payment.year = this.selectedYear.year;
    console.log("year changed"); // working
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/payment.component.ts